export const NAME_CHAR_MAP: Record<string, string> = {
  Á: "A",
  À: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  á: "a",
  à: "a",
  â: "a",
  ã: "a",
  ä: "a",
  É: "E",
  È: "E",
  Ê: "E",
  Ë: "E",
  é: "e",
  è: "e",
  ê: "e",
  ë: "e",
  Í: "I",
  Ì: "I",
  Î: "I",
  Ï: "I",
  í: "i",
  ì: "i",
  î: "i",
  ï: "i",
  Ó: "O",
  Ò: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  ó: "o",
  ò: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  Ú: "U",
  Ù: "U",
  Û: "U",
  Ü: "U",
  ú: "u",
  ù: "u",
  û: "u",
  ü: "u",
  Ç: "C",
  ç: "c",
  Ñ: "N",
  ñ: "n",
  Ý: "Y",
  Ÿ: "Y",
  ý: "y",
  ÿ: "y",
  "&": "E",
  ª: "",
  º: "",
  "°": "",
  "'": "",
  '"': "",
  "`": "",
  "´": "",
  "^": "",
  "~": "",
  "[": "",
  "]": "",
  "{": "",
  "}": "",
  ";": "",
  "!": "",
  "?": "",
};

export const NAME_ALLOWED_SPECIAL_CHARS = "|-:/_.()";

const escapeForCharClass = (chars: string): string =>
  chars.replace(/[\\\]^-]/g, "\\$&");

const NOT_ALLOWED = new RegExp(
  `[^A-Za-z0-9 ${escapeForCharClass(NAME_ALLOWED_SPECIAL_CHARS)}]`,
  "g"
);

export const sanitizeNameInput = (raw: string): string =>
  Array.from((raw ?? "").replace(/\s/g, " "))
    .map((char) => NAME_CHAR_MAP[char] ?? char)
    .join("")
    .replace(NOT_ALLOWED, "")
    .replace(/ {2,}/g, " ")
    .replace(/^ +/, "");

export const sanitizeName = (raw: string): string =>
  sanitizeNameInput(raw).trim();

export const isFullName = (name: string): boolean =>
  /[A-Za-z0-9][^A-Za-z0-9]+[A-Za-z0-9]/.test(name ?? "");
